// libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useParams, Link } from 'react-router-dom';

// helpers
import { getOptimisedImageUrl } from 'shared/helpers/utils';

// components
import Placeholder from './Placeholder';

// styles
import { Wrapper, ImageItem, RemainingItems, Img } from './styles';

const IMG_ALT = 'Customer review pic';
export interface IImageRailProps {
  imageList: ReviewAllImages.IImageItem[];
  handleClick: (imageData: ReviewAllImages.IImageClickCallBack) => void;
  totalCount: number;
  isFetching: boolean;
  isError: boolean;
}

const DEFAULT_IMAGE_WIDTH = 90;
const DEFAULT_IMAGE_HEIGHT = 120;
const MAX_LENGTH_TO_SHOW = 8;

function ImageRail({
  imageList,
  handleClick,
  totalCount = 0,
  isFetching,
  isError,
}: IImageRailProps) {
  const { id: productId, slug } = useParams<{ id: string; slug: string }>();
  const imagesToDisplay = imageList.slice(0, MAX_LENGTH_TO_SHOW);
  const showMore = totalCount > MAX_LENGTH_TO_SHOW;

  if (isFetching) {
    return <Placeholder />;
  }

  if (isError || isEmpty(imageList)) {
    return null;
  }

  return (
    <Wrapper>
      {imagesToDisplay.map(({ url, id }, index) => {
        const isViewMore = showMore && index === imagesToDisplay.length - 1;
        const onClick = () => handleClick({ url, id, index });

        if (isViewMore) {
          return (
            <Link to={`/${slug}/p/${productId}/review-images`} key={'ImageItem_' + index}>
              <ImageItem>
                <Img
                  src={getOptimisedImageUrl(url, {
                    width: DEFAULT_IMAGE_WIDTH * 2,
                  })}
                  height={DEFAULT_IMAGE_HEIGHT}
                  width={DEFAULT_IMAGE_WIDTH}
                  alt={IMG_ALT}
                />
                <RemainingItems>
                  <span>{`+ ${totalCount - (imagesToDisplay.length - 1)}`}</span>
                  <span>more</span>
                </RemainingItems>
              </ImageItem>
            </Link>
          );
        }

        return (
          <ImageItem key={'ImageItem_' + index} onClick={onClick}>
            <Img
              src={getOptimisedImageUrl(url, { width: DEFAULT_IMAGE_WIDTH * 2 })}
              height={DEFAULT_IMAGE_HEIGHT}
              width={DEFAULT_IMAGE_WIDTH}
              alt={IMG_ALT}
            />
          </ImageItem>
        );
      })}
    </Wrapper>
  );
}

export default memo(ImageRail);
